import { Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import type { ModelUploadStatusItem } from 'shared';
import { UploadStatusBadgeComponent } from '../../atoms/upload-status-badge/upload-status-badge.component';

@Component({
  selector: 'ocp-upload-status-list',
  imports: [
    TranslatePipe,
    HlmButtonImports,
    DatePipe,
    UploadStatusBadgeComponent,
    ThemedIconComponent,
  ],
  templateUrl: './upload-status-list.component.html',
  styleUrl: './upload-status-list.component.scss',
})
export class UploadStatusListComponent {
  items = input.required<ModelUploadStatusItem[]>();
  cancelUpload = output<ModelUploadStatusItem>();
  viewModel = output<ModelUploadStatusItem>();
  copyLink = output<ModelUploadStatusItem>();

  protected readonly hasItems = computed(() => this.items().length > 0);

  protected onCancel(item: ModelUploadStatusItem): void {
    this.cancelUpload.emit(item);
  }

  protected onViewModel(item: ModelUploadStatusItem): void {
    this.viewModel.emit(item);
  }

  protected onCopyLink(item: ModelUploadStatusItem): void {
    this.copyLink.emit(item);
  }

  protected isCancellable(item: ModelUploadStatusItem): boolean {
    return (
      item.status === 'Preparing' ||
      item.status === 'Processing' ||
      item.status === 'Uploading' ||
      item.status === 'Finalizing'
    );
  }
}
